import moment from 'moment'
import { getUUID } from '../../../common/common-utils'
import { defaultContractRoles, defaultContractRolesWithPartner } from '../../../common/defaults'
import {
  ClientProfile,
  Customer,
  Offer,
  Opportunity,
  Selections,
  AssessmentMethodType,
  FrontlineConfigJson,
  DopAndAccessData
} from '../../../../types/types'
import { getDefaultCommercialTerms } from '../../utils/commercialterms/CommercialTermsUtils'

export default function createEmptyOffer(
  customer: Customer,
  opportunity: Opportunity,
  profile: ClientProfile,
  frontlineConfig: FrontlineConfigJson,
  assessmentMethod: AssessmentMethodType
): Offer {
  const now = moment().format()
  const contractRoles = opportunity.partner != null ? defaultContractRolesWithPartner : defaultContractRoles
  const commercialTerms = getDefaultCommercialTerms(frontlineConfig, opportunity)

  return {
    active: true,
    assessmentEquipmentGroupAnswers: {},
    assessmentMethod,
    bundleGroupSelection: {},
    buildings: [],
    clientId: opportunity.id,
    customAttachmentSelection: [],
    customAttachmentComments: '',
    commercialTerms,
    completed: false,
    contacts: opportunity.contacts,
    contractFilenames: { gendoc: {} },
    contractParties: [],
    contractRoles,
    created_timestamp: now,
    customer,
    discountApprovalLevels: 0,
    discountApprovalComment: null,
    discountApprovalStatus: 'uninitialized',
    discountSummary: false,
    equipmentGroups: {},
    finalization_started: null,
    finalized: false,
    finalizationProgress: {},
    pricingEngineDiscountUsage: {
      isPricingEngineDiscountSet: false,
      discountPrediction: {
        good: 0,
        excellent: 0,
        average: 0,
        maximum: 0
      },
      discount: 0
    },
    isEscalationFlow: {
      active: false,
      rushContractType: '',
      numberOfEquipments: 0,
      initialContractAnnualPrice: 0,
      escalatedAnnualPrice: 0,
      escalatedPercentage: 0,
      finalizedTotalPrice: 0,
      interimTotalPrice: 0,
      escalationVasPrices: 0,
      escalationVasDiscountedPercentage: 0,
      escalationVasDiscountedPrices: 0
    },
    tenderVersionComment: '',
    id: getUUID(),
    initialData: {},
    interaction: {} as Selections,
    interactionRating: null,
    introductions: frontlineConfig.introductionTexts,
    isQuickTender: false,
    isContractStartDateAtEquipmentLevel: false,
    isBillingPlanAtEquipmentLevel: false,
    isOrderReasonAtEquipmentLevel: false,
    lastSyncStarted: null,
    modified_client: now,
    opportunity,
    opportunityId: opportunity.id,
    opportunityShares: [],
    partner: opportunity.partner,
    partners: opportunity.partner != null ? [opportunity.partner] : undefined,
    previousVersions: [],
    prices: [],
    quickTenderScope: null,
    salesOrganization: profile.salesOrganization,
    subSalesOrganization: profile.subSalesOrganization,
    salesforceTenderTimestamp: null,
    sapContractFilenames: [],
    selectedInteractionRating: null,
    sfUser: profile.displayName,
    sfTenderVersionActive: false,
    tenderId: null,
    tenderName: null,
    summaryAttachmentId: null,
    tenderVersionId: null,
    tenderVersionName: null,
    tenderVersionNumber: null,
    userId: profile.userId,
    warranty: frontlineConfig.warrantyOptions != null && frontlineConfig.warrantyOptions.length > 0 ? 0 : undefined,
    normalizedForCriticality: true,
    dxGrpId: '',
    isGroupsEdited: false,
    isGSMOffer: null,
    dopAndAccessData: {} as DopAndAccessData,
    additionalOfferInfo: {}
  }
}
